import React, { PropsWithChildren } from 'react';
import { Alert } from '@mui/material';
import { usePermissions } from 'hooks/Permission/usePermission';
import { PermissionMode } from 'contexts/PermissionProviderContext';

type PermissionGuardProps = PropsWithChildren<{
  permissions?: string | string[];
  mode?: PermissionMode;
  guardType?: 'element' | 'route';
}>;

export function PermissionGuard({ permissions, mode = 'all', guardType = 'element', children }: PermissionGuardProps) {
  const { hasPermission, loadState } = usePermissions();

  if (loadState === 'loading') {
    return null;
  }

  if (loadState === 'unauthenticated') {
    return guardType === 'route' ? <Alert severity="warning">Bejelentkezés szükséges.</Alert> : null;
  }

  if (loadState === 'error') {
    return guardType === 'route' ? <Alert severity="error">A jogosultságok betöltése nem sikerült.</Alert> : null;
  }

  if (!hasPermission(permissions ?? [], mode)) {
    return guardType === 'route' ? <Alert severity="warning">Nincs jogosultságod az oldal megtekintéséhez.</Alert> : null;
  }

  return <>{children}</>;
}
